import { render } from "./noPermission.vue?vue&type=template&id=561cd44a&scoped=true"
import script from "./noPermission.vue?vue&type=script&lang=js"
export * from "./noPermission.vue?vue&type=script&lang=js"

import "./noPermission.vue?vue&type=style&index=0&id=561cd44a&scoped=true&lang=css"

import exportComponent from "D:\\project\\gis_map\\xq_demo\\xq_demo_front\\xq_demo_admin_site_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561cd44a"]])

export default __exports__